import { IoAdd } from "react-icons/io5";
import { SiAirplayvideo } from "react-icons/si";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { api } from "../../api";
import browserRoutes from "../../common/browserRoutes";
import User from "../../components/User";
import CreatePostButton from "./components/CreatePostButton";

const Navbar = () => {
	
  return (
    <Wrapper>
      <LogoLink to={"/"}>
        <SiAirplayvideo />
        <p className="text">TukTok</p>
      </LogoLink>
			<CreatePostButton />
      <User />
    </Wrapper>
  );
};

const Wrapper = styled.nav(() => [
  tw`flex items-center gap-x-2`,
  css`
		& > * {
			${tw`h-2/3`};
		}
    padding: 0 var(--gap-x-global);
    height: var(--nav-h);
    border-bottom: var(--hr-border);

    ${User} {
      margin-left: auto;
    }
  `,
]);



const LogoLink = styled(Link)(() => [
  tw`flex items-center space-x-1 text-pink-600`,
  css`
    font-size: 1em;

    .text {
      font-family: "Phudu", cursive;
      font-weight: 500;
    }

    svg {
      font-size: 0.79em;
      margin-bottom: -3px;
    }
  `,
]);

export default styled(Navbar)``;
